/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Observable } from 'rxjs';
import { StaticDataType } from 'app/static-data/models';
import { NamedValue } from 'app/shared/models';

/** Implementations allow obtaining static data. */
export abstract class DataService {
  /**
   * Returns the values associated with the supplied enum type.
   *
   * @param enumType the type of the enum whose values to load
   * @return associated enum values
   */
  abstract loadEnumerationValues(enumType: StaticDataType): Observable<NamedValue<string>[]>;
}
